import { Easing } from "react-anime";

export const animeChildrenProps = {
  opacity: [0, 1],
  translateY: [-60, 0],
  duration: 500,
  easing: "easeInOutBack" as Easing,
  // delay: (_el: HTMLElement, i: number): number => (i * 100) / 1.5
};

export const animeSingleProps = {
  opacity: [0, 1],
  translateY: [-60, 0],
  duration: 500,
  easing: "easeInOutBack" as Easing
};

export const animeFadeInProps = {
  opacity: [0, 1],
  duration: 500,
  easing: "easeInOutBack" as Easing
};
